import React from "react";
import "./WhyChooseUs.scss";
import { FaPlane, FaUsers, FaMapMarkedAlt, FaStar } from "react-icons/fa";

const WhyChooseUs = () => {
  const features = [
    {
      icon: <FaPlane />,
      title: "Expert Travel Guidance",
      description:
        "Our experienced guides and travel experts ensure you get the most memorable journeys with complete safety.",
    },
    {
      icon: <FaUsers />,
      title: "Personalized Service",
      description:
        "We offer customized tour packages according to your preferences and travel style.",
    },
    {
      icon: <FaMapMarkedAlt />,
      title: "Unique Destinations",
      description:
        "Explore hidden gems and offbeat locations in Baltistan, Skardu, Hunza, and beyond.",
    },
    {
      icon: <FaStar />,
      title: "Trusted & Reliable",
      description:
        "We have a proven track record of providing excellent service to international travelers.",
    },
  ];

  return (
    <section className="why-choose-us">
      <div className="container">
        <div className="header">
          <h2>Why World Adventure Tours</h2>
        </div>
        <div className="features">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
